<template>
  <div class="p-6 rounded-lg border border-gray-300 shadow-md">
    <div class="flex items-center justify-between">
      <div class="text-lg font-bold text-center ml-4">
        {{ title }}
      </div>
      <a
        href="#"
        class="p-4 align-middle"
        @click.prevent="deleteQR"
      >
        <eva-icon
          class="align-middle"
          name="trash-outline"
          fill="#FF7570"
        />
      </a>
    </div>
    <div>
      <img :src="qrURL">
    </div>
  </div>
</template>

<script>
import qrcode from 'qrcode-generator'
import { mapState } from 'vuex'
import * as axios from 'axios'
export default {
  props: {
    codeID: {
      type: String,
      default: null,
    },
    data: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      qr: null,
      qrURL: '',
    }
  },
  computed: {
    ...mapState({
      instanceID: state => state.admin.instanceID,
    }),
  },
  mounted () {
    const typeNumber = 0
    const errorCorrectionLevel = 'L'
    this.qr = qrcode(typeNumber, errorCorrectionLevel)
    this.qr.addData(String(this.data))
    this.qr.make()
    this.qrURL = this.qr.createDataURL(4)
  },
  methods: {
    deleteQR () {
      console.info({
        codeID: this.codeID,
        instanceID: this.instanceID,
      })
      this.$f7.dialog.confirm('¿Estás seguro de que deseas eliminar este codigo?', '¿Seguro?', async () => {
        try {
          this.$f7.dialog.preloader('Eliminando QR...')
          const response = await axios({
            url: '/device/deleteNetworkLink',
            method: 'POST',
            data: {
              codeID: this.codeID,
              instanceID: this.instanceID,
            },
          })
          console.info(response)
        } catch (error) {
          console.error(error)
        } finally {
          this.$f7.dialog.close()
        }
      })
    },
  },
}
</script>
